import React from 'react';
import { uniq, range, split, map, compose, sortBy, identity } from 'ramda';
import { bool, string, func } from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import getYear from 'date-fns/get_year';
import format from 'date-fns/format';
import getMonth from 'date-fns/get_month';
import setYear from 'date-fns/set_year';
import setMonth from 'date-fns/set_month';
import isWithinRange from 'date-fns/is_within_range';

import { expandIntervalByMonths } from '../utils/time';

import Grid from './Grid';
import DropDownTitled from './DropDownTitled';

const getMonthsList = compose(
  sortBy(identity),
  uniq,
  map(getMonth),
  expandIntervalByMonths,
);

const getYearsList = compose(
  sortBy(identity),
  ([first, last]) => range(first, last + 1),
  map(getYear),
  split('/'),
);

const MonthYearPicker = ({ selected, title, yearsOnly, bounds, onChange }) => {
  const isEmpty = !selected || !bounds;

  const month = !isEmpty ? getMonth(selected) : '-';
  const year = !isEmpty ? getYear(selected) : '-';
  const [min, max] = !isEmpty ? bounds.split('/') : [null, null];

  return (
    <Grid style={{ marginRight: '24px' }}>
      <DropDownTitled
        title={title}
        value={month}
        disabled={isEmpty || yearsOnly}
        onChange={(e, i, val) => onChange(setMonth(selected, val))}
        iconStyle={{ fill: 'rgba(0,0,0,.87)' }}
      >
        {!isEmpty ? (
          getMonthsList(bounds).map(m => (
            <MenuItem
              key={m}
              disabled={!isWithinRange(setMonth(selected, m), min, max)}
              value={m}
              primaryText={format(new Date(1970, m, 1), 'MMM')}
            />
          ))
        ) : (
          <MenuItem value="-" primaryText="-" />
        )}
      </DropDownTitled>
      <DropDownTitled
        disabled={isEmpty}
        value={year}
        onChange={(e, i, val) => onChange(setYear(selected, val))}
        iconStyle={{ fill: 'rgba(0,0,0,.87)' }}
      >
        {!isEmpty ? (
          getYearsList(bounds).map(y => (
            <MenuItem
              key={y}
              disabled={!isWithinRange(setYear(selected, y), min, max)}
              value={y}
              primaryText={y}
            />
          ))
        ) : (
          <MenuItem value="-" primaryText="-" />
        )}
      </DropDownTitled>
    </Grid>
  );
};

MonthYearPicker.propTypes = {
  title: string,
  selected: string,
  bounds: string,
  yearsOnly: bool,
  onChange: func,
};

export default MonthYearPicker;



// WEBPACK FOOTER //
// ./src/components/MonthYearPicker.jsx